import RouteView from '@/router/RouteView.vue';
import Student from './index.vue';
import Statistics from './statistics.vue';
import StudentClass from './Class.vue';
import Detail from '../ClassManage/Detail.vue';

export default [
  {
    path: '/student',
    name: 'Student',
    component: RouteView,
    redirect: '/student/list',
    meta: {
      title: '学生管理',
    },
    children: [
      {
        path: '/student/list',
        name: 'StudentList',
        component: Student,
        meta: {
          title: '学生列表',
        },
      },
      {
        path: '/student/class/:id/:name/:mobile',
        name: 'StudentClass',
        component: StudentClass,
        meta: {
          title: '我的班级',
        },
      },
      {
        path: '/student/detail/:id',
        name: 'ClassDetail4',
        component: Detail,
        meta: {
          title: '班级详情',
        },
      },
      {
        path: '/student/statistics/:id/:name/:mobile',
        name: 'Statistics',
        component: Statistics,
        meta: {
          title: '上课记录',
        },
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/views/Student/index.js